import React from 'react';
import { TableSortLabel } from '@hopskipdrive/react-components';

import { colorPalette } from '../components/variables';

import { ColumnDef, SortState } from './types';

interface SortableColumnHeaderProps {
  column: ColumnDef;
  sortState: SortState;
  onSort: (column: string) => void;
}

export const SortableColumnHeader: React.FC<SortableColumnHeaderProps> = ({ column, sortState, onSort }) => {
  if (!column.sortable) {
    return <>{column.label}</>;
  }

  const isActive = sortState.column === column.key;
  const direction = isActive ? sortState.direction ?? undefined : undefined;

  return (
    <TableSortLabel
      active={isActive}
      direction={direction}
      onClick={() => onSort(column.key)}
      sx={{ '&.Mui-active .MuiTableSortLabel-icon': { color: colorPalette.orange73 } }}
    >
      {column.label}
    </TableSortLabel>
  );
};
